export default function ErrorState({ error }: { error: string }) {
  return (
    <div className="w-full flex items-center justify-center py-6">
      <p className="text-sm text-destructive">
        Yanıtlar yüklenirken hata oluştu: {error}
      </p>
    </div>
  );
}

